import AppleIcon from "@mui/icons-material/Apple";
import GoogleIcon from "@mui/icons-material/Google";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import LinkIcon from "@mui/icons-material/Link";

import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Calendar } from "./Icons";

type ManageProps = {
  volocalToken: string;
};

export const Manage = (props: ManageProps) => {
  const { volocalToken } = props;
  // Same origin serves the feed, so derive the host rather than hardcoding it.
  const webcalUrl = `webcal://${window.location.host}/cal/${volocalToken}`;
  const googleSubscribeUrl = `https://calendar.google.com/calendar/r?cid=${encodeURIComponent(
    webcalUrl
  )}`;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // The raw feed URL, for calendar apps that only take a subscription link.
  const [urlOpen, setUrlOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  return (
    <Stack direction="column" spacing={2}>
      <Card>
        <Box padding="2em">
          <Stack direction="column" spacing={2}>
            <Stack direction="row" alignItems="center" spacing={1.2}>
              <Box sx={{ color: "primary.main", display: "flex" }}>
                <Calendar width={22} height={22} />
              </Box>
              <Typography variant="h5">Calendar</Typography>
            </Stack>
            <Typography variant="body1" color="text.secondary">
              Add your Volo games to your phone or laptop calendar.
            </Typography>
            <Button
              variant="contained"
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              Add Volo Calendar
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem component={Link} href={webcalUrl}>
                <ListItemIcon>
                  <AppleIcon />
                </ListItemIcon>
                <ListItemText>iCal</ListItemText>
              </MenuItem>
              <MenuItem component={Link} href={googleSubscribeUrl}>
                <ListItemIcon>
                  <GoogleIcon />
                </ListItemIcon>
                <ListItemText>Google Calendar</ListItemText>
              </MenuItem>
              <MenuItem component={Link} href={webcalUrl}>
                <ListItemIcon>
                  <MicrosoftIcon />
                </ListItemIcon>
                <ListItemText>Outlook</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleClose();
                  setCopied(false);
                  setUrlOpen(true);
                }}
              >
                <ListItemIcon>
                  <LinkIcon />
                </ListItemIcon>
                <ListItemText>Webcal URL</ListItemText>
              </MenuItem>
            </Menu>

            <Dialog
              open={urlOpen}
              onClose={() => setUrlOpen(false)}
              maxWidth="sm"
              fullWidth
            >
              <DialogTitle>Webcal URL</DialogTitle>
              <DialogContent>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  Paste this into any calendar app that takes a subscription
                  link.
                </Typography>
                <TextField
                  variant="outlined"
                  value={webcalUrl}
                  fullWidth
                  InputProps={{ readOnly: true }}
                  onFocus={(e) => e.target.select()}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setUrlOpen(false)}>Close</Button>
                <Button
                  variant="contained"
                  onClick={async () => {
                    try {
                      await navigator.clipboard.writeText(webcalUrl);
                      setCopied(true);
                    } catch {
                      // Clipboard can be blocked; the field is selectable.
                    }
                  }}
                >
                  {copied ? "Copied" : "Copy"}
                </Button>
              </DialogActions>
            </Dialog>
          </Stack>
        </Box>
      </Card>
    </Stack>
  );
};
